// Author -Evan Lewis

// Main js script called by index.html
// Front end framework - Mithril

import m, { route } from 'mithril'


import page from './views/pages/onlinereader'
import page_copyright from './views/pages/onlinereader_copyright'
import layout from './views/layout'
// import layout from './views/layout'

route.prefix = ''

var root = document.body

let routes = {}

routes['/'] = {
    render: vnode => m(layout, m(page, vnode.attrs))
}
routes['/:*'] = {
    render: vnode => m(layout, m(page, vnode.attrs))
}

routes['/:*/all-summer-in-a-day?test=true'] = {
    render: vnode => {
        return m(layout, m(page, {story: 'all-summer-in-a-day'}))
    }
}

routes['/:*/all-summer-in-a-day'] = {
    render: vnode => {
        return m(layout, m(page_copyright, {story: 'all-summer-in-a-day'}))
    }
}

routes['/:*/:story'] = {
    render: vnode => {
        return m(layout, m(page, vnode.attrs))

    }
}



//Set all routes
//Home is default (libraryofalexandria.com -> /)
route(root, "/", routes);